var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{staticClass:"px-6 py-6",attrs:{"rounded":""}},[(_vm.label || _vm.$slots.label)?_c('ui-box-label',{staticClass:"mb-4"},[_vm._t("label",[_vm._v(" "+_vm._s(_vm.label)+" ")])],2):_vm._e(),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }